module.exports = __webpack_public_path__ + "img/wanderSaneHelmet.c7260ef7.svg";